import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpTogglerComponent from './adpToggler.component';

let adpTogglerModule = angular.module('adpToggler', [
  uiRouter
])

.component('adpToggler', adpTogglerComponent)

.name;

export default adpTogglerModule;



// WEBPACK FOOTER //
// ./src/app/components/adpToggler/adpToggler.js